export default {
  position: 'top'
};